export const REFUND_STRINGS = {
  confirmRefund: 'Confirm Refund',
  bcConfirmation: 'BC Agent - Confirmation',
  agentMobile: 'Agent Mobile Number',
  otp: 'OTP',
  OK: 'OK',
  wait: 'Please Wait...',
  beneficiaryValidationProgress: 'Beneficiary validation is in progress.',
  proceedAsEntered: 'Proceed as entered',
  update: 'Update',
  beneficiaryName: 'Beneficiary Name',
  beneficiaryAcNum: 'Beneficiary Account Number',
  mismatchBankRecord: 'mismatch from bank records',
  asPerBank: 'as per bank is',
  pendingRefund: 'Pending Refunds',
  trnxRefNo: 'Transaction Ref No',
  date: 'Date',
  Amount: 'Amount',
  validateRefundCode: 'Validate Refund Code',
  enterRefundCode: 'Enter Refund Code',
  reRegenerateCode: 'Re-Generate Refund Code',
  initiateRefund: 'Initiate Refund',
  refundDetails: 'Refund Details',
  customerName: 'Customer Name',
  trnxType: 'Transaction Type',
  refundAmt: 'Refund Amount',
  trnxId: 'Transaction ID',
  refundFailed: 'REFUND FAILED',
  refundSuccess: 'REFUND SUCCESS',
  refundPending: 'REFUND PENDING',
  fetchTrnx: 'Fetch Transactions',
  generateOtp: 'Generate OTP',
  utrRefCode: 'Reference No. / UTR',
  domesticRemittance: 'Domestic Remittance',
  enterUtrRefCode: 'Enter UTR Reference Code',
  enterCustomerMob: 'Enter Customer Mobile',
  selectService: 'Select a Service',
  goBack: 'Go Back',
  beneficiaryMobile: 'Beneficiary Mobile',
  refundCodeGenerationFailed: 'Refund Code Generation Failed',
  refundCodeGenerationSuccess: 'Refund Code Generated & Sent Successfully',
  refundCodeGenerationPending: 'Refund Code Generation Pending',
  voucherStatus: 'Voucher Status',
  applicantMonileNo: 'Applicant’s Mobile Number',
  remitterName: 'Customer Name',
  remitterMobile: 'Customer Mobile',
}
